import styled from "styled-components";

const Style = styled.div`
  padding-top: 16px;
  text-align: center;
`;

export default Style;
